import { ComponentProps, PropsWithChildren } from 'react';
import { useCalendarDragState } from '../calendar-grid/calendar-drag-state-context';

export const ColumnHeaderWrapper = ({
  children,
  containerStyle,
  ...rest
}: PropsWithChildren<ComponentProps<'div'>> & {
  containerStyle?: any;
}) => {
  const { isColumnHeaderDragOverlay, columnHeaderDragOverlayStyle } = useCalendarDragState();

  return (
    <div css={[{ width: '100%' }, containerStyle, isColumnHeaderDragOverlay && columnHeaderDragOverlayStyle]} {...rest}>
      {children}
    </div>
  );
};
